import React , { useState , useEffect } from 'react';
import webapi from '../../../api/webapi';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import TagsBody from './TagsBody';

const Tags = (props) =>{
    
    const [languageInfo,setLanguageInfo] = useState(undefined)

    useEffect (()=>{
        async function getLanguageInfo(LanguageCode){
            
        const responseResultlanguageinfo = await webapi.get('pages/languageInfo/'+LanguageCode);
        //console.log(responseResultlanguageinfo.data.length);
        //console.log(responseResultlanguageinfo.data);
        
        if (responseResultlanguageinfo!==undefined && responseResultlanguageinfo.data.length>0)
        {
            setLanguageInfo(responseResultlanguageinfo.data);
            //setState({lang : responseResultlanguageinfo.data[0].Code});
            document.getElementsByTagName('html')[0].setAttribute("lang", responseResultlanguageinfo.data[0].Code);
            document.getElementsByTagName('html')[0].setAttribute("dir", responseResultlanguageinfo.data[0].Direction);
        }
        else
        {
            setLanguageInfo([{Code:"fa",Title:"فارسی",Direction:"rtl"}]);
            //setState({lang : responseResultlanguageinfo.data[0].Code});
            document.getElementsByTagName('html')[0].setAttribute("lang","fa");
            document.getElementsByTagName('html')[0].setAttribute("dir", "rtl");
        }
    }

        if (new URLSearchParams(props.location.search).get("lang")!=null)
        {
            //console.log('LangFromURL: ',new URLSearchParams(props.location.search).get("lang"));
            //console.log('LangFromSubDomain: ',window.location.host.split(".")[0]);
            getLanguageInfo(new URLSearchParams(props.location.search).get("lang"));
            //console.log(languageInfo);
        }else{
            setLanguageInfo([{Code:"fa",Title:"فارسی",Direction:"rtl"}]);
            document.getElementsByTagName('html')[0].setAttribute("lang","Fa");
            document.getElementsByTagName('html')[0].setAttribute("dir", "rtl");
            //getPage();
        }
    },[])

    

    
    if (languageInfo) {
        return (
            <div>
                <Header     languageInfo = {languageInfo}/>
                <TagsBody    languageInfo = {languageInfo}/>
                <Footer     lang = {languageInfo[0].Code}/>
            </div>
        )
    }
    else
    {
        return (
            <div></div>
        )
    }
 }

 export default Tags;

